import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { PROJECT_FORMS_LOCAL_API_REQUESTS } from './constants';

// GET projects/{projectId}/forms/summary
// -> { groups: Group[], complete: boolean, source: 'index'|'fallback' }
export const getProjectFormsSummary = async ({ projectId }) => {
  const apiPath = `projects/${projectId}/forms/summary`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: PROJECT_FORMS_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data;
};
